export const getIP = async () => {
    let ip = await fetch('https://api.ipify.org?format=json').then((res) => res.json()).then((data) => data.ip)

    if (!ip) {
        ip = await fetch('http://ipwho.is/').then((res) => res.json()).then((data) => data.ip)
    }

    if (ip) {
        // check if is a valid ip4
        const ipRegex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
        if (!ipRegex.test(ip)) {
            throw new Error('Invalid IP address')
        }
    }

    return ip
}